export default __webpack_public_path__ + "static/media/assignQuickSightUser.3d2c3d93.svg";